import { render, staticRenderFns } from "./EventType.vue?vue&type=template&id=0541df25&scoped=true"
import script from "./EventType.vue?vue&type=script&lang=js"
export * from "./EventType.vue?vue&type=script&lang=js"
import style0 from "./EventType.vue?vue&type=style&index=0&id=0541df25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541df25",
  null
  
)

export default component.exports